import { isIos } from './system';

/**
 * 是否为iPhone X、iPhone XS
 */
export const isIphoneX =
    isIos && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;

/**
 * 是否为iPhone XS Max
 */
export const isIphoneXSMax =
    isIos && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;

/**
 * 是否为iPhone XR
 */
export const isIphoneXR =
    isIos && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
